import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "80",
  height: "80",
  viewBox: "0 0 80 80",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      x: "0.5",
      y: "0.5",
      width: "79",
      height: "79",
      rx: "3.5",
      stroke: "#AA1E2D",
      "stroke-dasharray": "8 8"
    }, null, -1),
    _createElementVNode("path", {
      d: "M30 40H50",
      stroke: "#AA1E2D",
      "stroke-width": "2"
    }, null, -1),
    _createElementVNode("path", {
      d: "M40 30V50",
      stroke: "#AA1E2D",
      "stroke-width": "2"
    }, null, -1)
  ]))]))
}
export default { render: render }